// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__29LGl","question":"Question_question__2Klf-","description":"Question_description__1Wpvn"};